import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const headerStyles = {
    wrap: css`
        position: relative;
        z-index: 10;
        background: ${colors.darkSecondary};
        border-bottom: 1px solid rgba(69, 148, 255, 0.22);
    `,
    content: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 70px;

        .header-right {
            position: relative;
            display: flex;
            align-items: center;
        }
    `,
    logo: css`
        width: 132px;
        cursor: pointer;
        position: relative;
        display: flex;
        gap: 15px;
        img {
            width: 100%;
        }
    `,

    userHeader: css`
        .headerTop {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    `,
    btnLeft: css`
        background: rgba(69, 148, 255, 0.1);
        display: flex;
        align-items: center;
        border-radius: 20px;
        min-height: 36px;
        padding: 0 9px;
        border: 0;
    `,
    wrapBtnAccount: css`
        position: relative;
        &::after {
            content: '';
            position: absolute;
            left: -12px;
            right: -12px;
            top: -10px;
            bottom: -12px;
            background: transparent;
        }
    `,
    btnAccount: css`
        gap: 7px;
        transition: background 180ms ease, transform 180ms ease;
        position: relative;
        background: rgba(69, 148, 255, 0.1);

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 100%;
            width: 100%;
            height: 0;
            background: ${colors.white};
        }
    `,
    username: css`
        font-size: 14px;
        color: #f4f4f5;
        font-weight: 700;
        line-height: 18px;
    `,
    avatar: css`
        width: 24px;
    `,
    arrow: css`
        width: 10px;
        height: auto;
    `,
    notification: css`
        width: 15px;
        height: auto;
        max-height: 25px;
        object-fit: contain;
    `,
    balancePill: css`
        display: inline-flex;
        align-items: center;
        gap: 3px;
        min-height: 36px;
        padding: 0 10px;
        border-radius: 20px;
        background: rgba(69, 148, 255, 0.1);
        cursor: pointer;
        transition: background 180ms ease, transform 180ms ease;
        &:hover { background: rgba(69, 148, 255, 0.2); transform: translateY(-1px); }
    `,
    notificationButton: css`
        position: relative;
        display: grid;
        place-items: center;
        width: 25px;
        height: 36px;
        cursor: pointer;
        transition: transform 180ms ease;
        &:hover { transform: translateY(-2px); }
    `,
    countUnreadMsg: css`
        position: absolute;
        left: 13px;
        top: 0;

        background: ${colors.red};
        min-width: 18px;
        height: 16px;
        border-radius: 20px;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 0 3px;
        font-size: 10px;
        color: ${colors.white};
        line-height: 0;
    `,

    walletAction: css`
        height: 36px;
        padding: 0 16px;
        border-radius: 8px;
        color: ${colors.white};
        font-size: 15px;
        font-weight: 700;
        white-space: nowrap;
        transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;
        &:hover { transform: translateY(-2px); filter: brightness(1.1); box-shadow: 0 7px 16px rgba(0,0,0,.25); }
    `,
    depositAction: css`background: ${colors.darkRed};`,
    withdrawAction: css`background: ${colors.secondary}; color: ${colors.blackText};`,
    logoutAction: css`border: 1px solid #2c5490; background: transparent;`,
    viewNotification: css`
        width: 1300px;
        margin: auto;
        padding-top: 5px;
        padding-bottom: 5px;
        display: flex;
        align-items: center;
        overflow: hidden;
        .notiText {
            background: -webkit-linear-gradient(28deg, #ddca8c, #fcf3d4, #ddca8c, #fcf3d4, #ddca8c);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-left: 5px;
            text-transform: uppercase;
            font-size: 14px;
            width: 100px;
            z-index: 10;
        }
    `,
    contentNoti: css`
        display: flex;
        gap: 20px;
        white-space: nowrap;
        flex: 1;
        position: relative;

        .content {
            margin-left: 20px;
            margin-right: 20px;
            color: #fff;
            font-size: 14px;
            position: relative;
            text-decoration: underline;
            z-index: -1;
        }
        @keyframes marqueeScroll {
            from {
                transform: translateX(100%);
            }
            to {
                transform: translateX(-200%);
            }
        }
    `,

    cashReal: css`
        position: relative;
        display: inline-flex;
        align-items: center;
        gap: 2px;
    `,

    balanceText: css`
        font-size: 14px;
        color: #fbe98b;
        font-weight: 700;
        line-height: 20px;
        margin: 0;
    `,
};

export const fullMarquee = css`
    animation: fullScroll 12s linear infinite;

    @keyframes fullScroll {
        0% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(-100%);
        }
    }
`;

export const halfMarquee = css`
    animation: halfScroll 6s linear infinite;

    @keyframes halfScroll {
        0% {
            transform: translateX(-50%);
        }
        100% {
            transform: translateX(-100%);
        }
    }
`;

export default headerStyles;
